import type { FlightContext, LodgingContext } from "@checkout/states";

export const isFlightProduct = (context: any) =>
  (context as FlightContext).flightShop !== undefined;

export const isLodgingProduct = (context: any) =>
  (context as LodgingContext).lodgingShop !== undefined;
